import { useCallback } from 'react'
import shopWebsiteService from '@/services/shopWebsiteService'

const SESSION_KEY = 'oms_analytics_session'

function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_KEY)
  if (!id) {
    id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
    sessionStorage.setItem(SESSION_KEY, id)
  }
  return id
}

export function useShopAnalytics(slug: string | undefined, previewToken?: string | null) {
  const track = useCallback(
    (
      eventType: 'page_view' | 'add_to_cart' | 'checkout_start' | 'order_complete',
      extra?: { page_path?: string; product_id?: number; order_id?: number }
    ) => {
      if (!slug || previewToken) return
      void shopWebsiteService.recordAnalyticsEvent(
        slug,
        {
          event_type: eventType,
          page_path: extra?.page_path ?? window.location.pathname,
          product_id: extra?.product_id,
          order_id: extra?.order_id,
          session_id: getSessionId(),
        },
        previewToken
      )
    },
    [slug, previewToken]
  )
  return { track }
}
